import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useGreaterThanOptions = (): DropdownItemProps<boolean>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return [
      { key: 'GreaterThan', value: true, stringValue: 'GreaterThan', label: t('GreaterThan') },
      { key: 'LessThan', value: false, stringValue: 'LessThan', label: t('LessThan') },
    ];
  }, [t]);
};
